(function(angular){
	'use strict';
	
	angular
		.module('redemptionRequestModule', [
			'agreementsModule',
			'coreModule',
			'formValidationModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);